import { render, staticRenderFns } from "./top-logs.vue?vue&type=template&id=b4a094c8&scoped=true"
import script from "./top-logs.vue?vue&type=script&lang=js"
export * from "./top-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a094c8",
  null
  
)

export default component.exports